// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { ClientEffects } from './store/effects';
import * as fromClient from './store/reducer';

// SERVICES
import { ClientStoreService } from './client-store.service';
import { ClientService } from './services/client.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['client'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure Client ngrx related stuff.
 *
 *   @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 4-24-2020 Client store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('client', fromClient.reducer, { metaReducers }),
    EffectsModule.forFeature([ClientEffects]),
  ],
  declarations: [],
  providers: [
    ClientService,
    ClientStoreService,
  ],
})
export class ClientStoreModule { }
